import { UntitledIcon } from '@faceup/icons'
import { ulArrowLeft } from '@faceup/icons/ulArrowLeft'
import { defineMessages, useIntl } from '@faceup/localization'
import { Button } from '@faceup/ui-base'
import { useContext } from 'react'
import { type FragmentType, getFragmentData, graphql } from '../../../../../../__generated__'
import { LayoutContext } from '../../../../../../Contexts/LayoutContext'
import LanguageDropdown from '../../../../../LanguageDropdown'
import { LogoutButton } from '../../../../../LogoutButton'
import { PartnerInstitutionLogo } from '../PartnerInstitutionLogo'
import { PagesMenu } from './components'

const messages = defineMessages(
  'followUp.components.institutionLayout.components.header.components.headerComplexWithPages',
  [
    { id: 'openMenu', defaultMessage: '' },
    { id: 'closeMenu', defaultMessage: '' },
  ] as const
)

const fragments = {
  HeaderComplexWithPages_reportSource: graphql(`
    fragment HeaderComplexWithPages_reportSource on PublicReportSource {
      id
      languages
      defaultLanguage

      ...PartnerInstitutionLogo_reportSource
      ...PagesMenu_reportSource
    }
  `),
}

type HeaderComplexWithPagesProps = {
  reportSource: FragmentType<typeof fragments.HeaderComplexWithPages_reportSource>
  isMenuOpened: boolean
  setIsMenuOpened: (isOpened: boolean) => void
}

export const HeaderComplexWithPages = ({
  isMenuOpened,
  setIsMenuOpened,
  reportSource: _reportSource,
}: HeaderComplexWithPagesProps) => {
  const reportSource = getFragmentData(fragments.HeaderComplexWithPages_reportSource, _reportSource)
  const { client } = useContext(LayoutContext)
  const { formatMessage } = useIntl()
  const isApp = client === 'app'

  return (
    <div className='flex items-center w-full h-full'>
      <div className='flex flex-grow basis-0 justify-start items-center max-h-full min-w-0 overflow-hidden'>
        <PartnerInstitutionLogo reportSource={reportSource} />
      </div>
      <div className='hidden sm:flex flex-grow-[2] basis-0 justify-center mx-16 overflow-hidden min-w-0'>
        <PagesMenu reportSource={reportSource} />
      </div>
      <div className='hidden sm:flex flex-grow basis-0 justify-end items-center min-w-0'>
        {reportSource.languages.length > 1 && (
          <LanguageDropdown
            availableLanguages={reportSource.languages}
            defaultLanguage={reportSource.defaultLanguage}
          />
        )}
        {isApp && <LogoutButton />}
        <div className='sm:hidden'>
          <Button
            type='text'
            icon={<UntitledIcon icon={ulArrowLeft} size={24} />}
            label={formatMessage(isMenuOpened ? messages.closeMenu : messages.openMenu)}
            onClick={() => setIsMenuOpened(!isMenuOpened)}
          />
        </div>
      </div>
    </div>
  )
}
